// Copyright 2025, University of Maryland, All Rights Reserved
/**
 * Context for pipeline node common props.
 *
 * Auto-injects common props to BaseNode so node authors
 * don't need to manually pass them in every WorkflowNode.
 *
 * Props injected: fromApp, isExtension, instanceName, configured, status, selected
 */
import { createContext, useContext } from 'react'
import type { NodeStatus } from '../types'

export interface PipelineNodeContextValue {
  /** Node is inherited from app workspace (locked, read-only) */
  fromApp?: boolean
  /** Node is a workspace-specific extension (editable) */
  isExtension?: boolean
  /** Instance name shown in tooltip (from data.label) */
  instanceName?: string
  /** Whether the node is configured */
  configured?: boolean
  /** Current execution status */
  status?: NodeStatus
  /** Whether the node is selected in the canvas */
  selected?: boolean
}

const PipelineNodeContext = createContext<PipelineNodeContextValue>({})

export const PipelineNodeProvider = PipelineNodeContext.Provider

export const usePipelineNodeContext = (): PipelineNodeContextValue =>
  useContext(PipelineNodeContext)
